import axios, { AxiosError, AxiosResponse } from 'axios'
import { APIRequestErrorType, Endpoint, RoleMimetype, URL } from 'constants/API'

import { expose } from 'comlink'
import { ActionTypeAPIData } from 'constants/redux'
import { APIRequest } from 'models/API'
import { LoadEditedVisualResponse } from 'models/editingVisuals'
import { ActionRequest } from 'models/redux'
import { UrlDTO } from 'models/visuals'
import { generalFetch } from 'redux/Helpers'
import { ActionLoadEditedVisual } from 'redux/Individual/VisualsEditing/LoadEditedVisuals/loadEditedVisual.actions'
import { decideErrorType } from 'utils/APIDecideErrorType'

const delayTime = 2000
const iterationCount = 30

const waitFor = (millis: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, millis)
  })
}

async function loadEditedVisualWorker(receivedAction: ActionLoadEditedVisual, token: string, mimetype: RoleMimetype) {
  const { assignmentId, filename, jobId, visualType } = receivedAction.payload
  const url = URL + Endpoint.EDITED_VISUAL_DOWNLOAD_URL
    .replace('{assignmentId}', encodeURIComponent(assignmentId.toString()))
    .replace('{jobId}', encodeURIComponent(jobId.toString()))
    .replace('{filename}', encodeURIComponent(filename.toString()))
    .replace('{type}', encodeURIComponent(visualType.toString()))

  const fetchFunction = () => generalFetch(ActionTypeAPIData.LOAD_EDITED_VISUAL, () => axios.post<UrlDTO>(url, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: mimetype,
    },
  }))

  let actionContainingSignedUrl: ActionRequest = await fetchFunction()

  for (let i = 0; i < iterationCount; i++) {
    if (actionContainingSignedUrl.payload.request.response?.status !== 404) break
    await waitFor(delayTime)
    actionContainingSignedUrl = await fetchFunction()
  }

  const URLResponse: UrlDTO = actionContainingSignedUrl.payload.request.data
  const loadedAction: ActionLoadEditedVisual = {
    ...actionContainingSignedUrl,
    payload: {
      ...receivedAction.payload,
      ...actionContainingSignedUrl.payload,
      signedUrl: URLResponse?.url,
    }
  }

  if (loadedAction.payload.request.response) {
    const { data, headers, status, statusText, config } = loadedAction.payload.request.response
    const newResponse: AxiosResponse = { data, headers, status, statusText, config: JSON.parse(JSON.stringify(config)) }
    loadedAction.payload.request.response = newResponse
  }

  if (!URLResponse?.url) {
    const error_message = `signedUrl for edited visual ${filename} is undefined, null or empty`
    console.error(error_message)
    loadedAction.payload.request.error_type = APIRequestErrorType.UNKNOWN_ERROR
    loadedAction.payload.request.error = error_message
    return loadedAction
  }

  for (let i = 0; i < iterationCount; i++) {
    try {
      await axios.get<unknown>(URLResponse.url)
      return loadedAction
    } catch (error) {
      const axiosErr = error as AxiosError
      const errorRequest = APIRequest.factoryError<LoadEditedVisualResponse>(decideErrorType(axiosErr), axiosErr)
      loadedAction.payload.request = errorRequest
    }
    await waitFor(delayTime)
  }

  loadedAction.payload.request = APIRequest.factoryError(APIRequestErrorType.NOTFOUND_ERROR, 'Edited visual not found')

  return loadedAction
}

export type loadEditedVisualWorkerType = typeof loadEditedVisualWorker

expose(loadEditedVisualWorker)
